import { ginzaxiaomaApiRequest } from 'apis';
import {
  PmsProductWantRequestListQuery,
  PmsProductWantRequestMatchItem,
  PmsProductWantRequestOperateLog,
  PmsProductWantRequestRecord,
  PmsProductWantRequestSaveDto,
} from 'types/pms-product-want-request';

export const productWantRequestList = (
  data: PmsProductWantRequestListQuery,
) => {
  return ginzaxiaomaApiRequest.post<{
    list: PmsProductWantRequestRecord[];
    total: number;
  }>('/admin/pms/product-want-request/list', data);
};

export const productWantRequestDetail = (id: number) => {
  return ginzaxiaomaApiRequest.get<PmsProductWantRequestRecord>(
    `/admin/pms/product-want-request/${id}`,
  );
};

export const productWantRequestCreate = (
  data: PmsProductWantRequestSaveDto,
) => {
  return ginzaxiaomaApiRequest.post<PmsProductWantRequestRecord>(
    '/admin/pms/product-want-request/create',
    data,
  );
};

export const productWantRequestUpdate = (
  id: number,
  data: PmsProductWantRequestSaveDto,
) => {
  return ginzaxiaomaApiRequest.post<PmsProductWantRequestRecord>(
    `/admin/pms/product-want-request/update/${id}`,
    data,
  );
};

export const productWantRequestUpdateStatus = (
  id: number,
  data: {
    status: PmsProductWantRequestRecord['status'];
    remark?: string;
  },
) => {
  return ginzaxiaomaApiRequest.post<PmsProductWantRequestRecord>(
    `/admin/pms/product-want-request/update-status/${id}`,
    data,
  );
};

export const productWantRequestDelete = (id: number) => {
  return ginzaxiaomaApiRequest.post<PmsProductWantRequestRecord>(
    `/admin/pms/product-want-request/delete/${id}`,
  );
};

export const productWantRequestOperateLogList = (
  id: number,
  data: { pageNum: number; pageSize: number },
) => {
  return ginzaxiaomaApiRequest.post<{
    list: PmsProductWantRequestOperateLog[];
    total: number;
  }>(`/admin/pms/product-want-request/${id}/operate-log/list`, data);
};

export const productWantRequestMatches = (
  id: number,
  data: {
    pageNum?: number;
    pageSize?: number;
    minScore?: number;
    stockStatus?: string;
  },
) => {
  return ginzaxiaomaApiRequest.post<{
    list: PmsProductWantRequestMatchItem[];
    total: number;
  }>(`/admin/pms/product-want-request/${id}/matches`, data);
};

export const productWantRequestSendEmail = (
  id: number,
  data: { productIds: number[] },
) => {
  return ginzaxiaomaApiRequest.post<{ success: boolean }>(
    `/admin/pms/product-want-request/${id}/send-product-email`,
    data,
  );
};
